export const SEARCH_DATE_FORMAT = "yyyy-MM-dd";
export const initialSearchSegment = {
    from: [],
    to: [],
    departureDate: undefined,
    returnDate: undefined
};
export const initialFareCalendarState = {
    data: {},
    fetchedRanges: [],
    loading: false,
    error: null,
    maxOfferWindowDays: 7
};
export const getInitialState = () => ({
    type: "ROUNDTRIP",
    searchSegments: [initialSearchSegment],
    adults: 1,
    children: [],
    cabinClass: "ECONOMY",
    isDirect: false,
    initial: true,
    fareCalendar: initialFareCalendarState,
    dataCollectionPrices: {},
    recentSearchHistory: []
});
